/**
 * DetailRelated component.
 */
import DetailContext from '@shared/components/utils/context/detailContext';
import DetailRelatedContainer from '@components/atoms/container/detailRelatedContainer';
import Focus from '@shared/types/enums/focus';
import MainContext from '@shared/components/utils/context/mainContext';
import RailsList from '@components/sections/list/railsList/railsList';
import { pushFocus, setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useCallback, useContext, useEffect } from 'react';

/**
 * Displays the detail related section.
 */
export default function DetailRelated() {
  // ------------------------------------------------------------
  // Variables
  // ------------------------------------------------------------

  // Dispatch
  const dispatch = useAppDispatch();

  // Context
  const { focusable, related } = useContext(DetailContext);

  // ------------------------------------------------------------
  // Effect hooks
  // ------------------------------------------------------------

  useEffect(() => {
    if (related) {
      focusable.current.related = true;
    }
  }, [related]);

  // ------------------------------------------------------------
  // Actions
  // ------------------------------------------------------------

  /**
   * Handles the mouse enter event. Focuses the related section.
   */
  const onMouseEnter = useCallback(() => {
    dispatch(setFocus([parseInt(`${Focus.RAILS_SUB_LIST}${0}`)]));
  }, []);

  /**
   * Handles the out of bounds event. Pushes the menu focus.
   */
  const outOfBounds = useCallback(
    (_focus: Focus | number | string, exit?: string) => {
      if (_focus === Focus.RAILS_LIST) return;
      if (exit === 'LEFT') {
        dispatch(pushFocus(Focus.MENU));
      }
    },
    []
  );

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return related ? (
    <MainContext.Provider
      value={{
        complete: true,
        onChangeElement: () => null,
        outOfBoundsAction: outOfBounds,
        setAsset: () => null,
      }}
    >
      <DetailRelatedContainer id={'detailRelated'}>
        <RailsList
          rails={[related]}
          onItemClick={() => null}
          onMouseEnter={onMouseEnter}
        />
      </DetailRelatedContainer>
    </MainContext.Provider>
  ) : null;
}
